import { takeEvery, put } from "redux-saga/effects";
import * as ReasonsActions from "./reasonActions";
import { makeApiCall } from "../helpers";
import taskServices from "../../services/taskServices";

export const watchReasonsRequests = function* () {
    yield takeEvery(ReasonsActions.REQUEST_REASONS, fetchReasons);
    yield takeEvery(ReasonsActions.REQUEST_COMPLETE_REASONS, fetchCompleteCodeReasons);
    //yield takeEvery(RDDActions.SAVE_BILLING_SKU_INFO, saveBillingInfo);
};

const fetchReasons = function* (action) {
    try {
        const reasons = yield makeApiCall(taskServices.getReasons);
        if (reasons) {
            var result = new Map();
            reasons.forEach((reason) => {
                // reason is the only object that does not follow lang convention of being snake_case
                const { nameEn, nameFr, ...restOfReason } = reason;
                if (result.has(reason.reasonCodeType))
                    result.set(reason.reasonCodeType, [...result.get(reason.reasonCodeType), { name_en: nameEn, name_fr: nameFr, ...restOfReason }]);
                else {
                    result.set(reason.reasonCodeType, [{ name_en: nameEn, name_fr: nameFr, ...restOfReason }]);
                }
            });

            yield put(ReasonsActions.requestReasonsSucceeded(result));
        }
    } catch (responseError) {
        yield put(ReasonsActions.requestReasonsFailed());
    }
};

const fetchCompleteCodeReasons = function* () {
    try {
        const reasons = yield makeApiCall(taskServices.getCompleteCodeReasons);
        const filteredReason =
            reasons?.length > 0
                ? reasons.map((reason) => {
                      const { name_en, name_fr, ...restOfReason } = reason;
                      return {
                          ...restOfReason,
                          nameEn: name_en,
                          nameFr: name_fr,
                      };
                  })
                : [];
        yield put(ReasonsActions.requestCompleteReasonsSucceeded(filteredReason));
    } catch (responseError) {
        yield put(ReasonsActions.requestCompleteReasonsFailed());
    }
};
